// extracted by mini-css-extract-plugin
export default {"root":"AIModelHistoryPage_root__cAMAr"};